<template>
  <div class="flash-sale__carousel">
      <div class="flash-sale__caroudel__wrapper relative overflow-auto">
          <ul class="flash-sale__caroudel__list flex absolute">
              <li v-for="(item, index) in data" :key="index" class="flash-sale__caroudel__item relative">
                  <a href="" class="flash-sale__caroudel__item--link flex flex-col items-center justify-between h-full">
                      <div :style="url(item.url)" class="flash-sale__caroudel__item__img"></div>
                      <div class="flash-sale__caroudel__item__price flex-1 text-primary-color w-full px-8">
                          <div class="flash-sale__caroudel__item__price--text text-3xl">{{ item.price }} บาท</div>
                          <div class="flash-sale__caroudel__item__price--progress rounded-3xl bg-primary-f1-color relative">
                              <div :style="widthProgress(item.sold)" class="flash-sale__caroudel__item__price--progress-bar h-full bg-primary-color"></div>
                              <span class="flash-sale__caroudel__item__price--progress__text absolute text-center">{{ item.sold }}%</span>
                          </div>
                      </div>

                      <span class="flash-sale__caroudel__item--discount absolute flex flex-col items-center justify-around text-2xl">
                          <div class="flash-sale__caroudel__item--discount-price text-primary-color">-{{ item.discount }}%</div>
                      </span>
                  </a>
              </li>
          </ul>
      </div>
  </div>
</template>

<script>
export default {
    name: 'FlashSaleList',
    setup(){
        const data = [
            {
                url: 'https://down-th.img.susercontent.com/file/c6c58283b9b4214880c43e6d698aed39',
                price: '199',
                sold: '56',
                discount: '56'
            },
            {
                url: 'https://down-th.img.susercontent.com/file/th-11134207-7r98r-lud227c3aiohdc',
                price: '990',
                sold: '15',
                discount: '15'
            },
            {
                url: 'https://down-th.img.susercontent.com/file/cn-11134207-7r98o-lwgvrph2q24l4b',
                price: '29',
                sold: '72',
                discount: '72'
            },
            {
                url: 'https://down-th.img.susercontent.com/file/th-11134207-7r98s-lln88ndw4d8uf0',
                price: '17,950',
                sold: '8',
                discount: '8'
            },
            {
                url: 'https://down-th.img.susercontent.com/file/th-11134207-7r98t-lwi2nhqnid9s37',
                price: '929',
                sold: '44',
                discount: '44'
            },
            {
                url: 'https://down-th.img.susercontent.com/file/th-11134207-7r98o-lkw89ddpyyqy3c',
                price: '5',
                sold: '4',
                discount: '4'
            }
        ]

        var itemShow = 6
        var quantity = data.length
        const lengthOne = 100 / itemShow
        var width = `width: ${lengthOne * quantity}%;`

        return{
            width,
            data
        }
    },
    methods: {
        url: function (url) {
            return `background-image: url(${url});`;
        },
        widthProgress: function(sold){
            return `width: ${sold}%;`;
        }
    }
}
</script>

<style scoped>
.flash-sale__caroudel__wrapper{
    height: 24rem;
}

.flash-sale__caroudel__list{
    transition: all 500ms ease 0s;
    top: 0;
    left: 0;
    bottom: 0;
}

.flash-sale__caroudel__item{
    width: 20rem;
    height: 24rem;
}

.flash-sale__caroudel__item__img{
    width: 80%;
    height: 80%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

.flash-sale__caroudel__item__price--progress{
    width: 100%;
    height: 17px;
}

.flash-sale__caroudel__item__price--progress-bar{
    /* width: 70%; */
        background-image: linear-gradient(45deg,
            rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,
            rgba(255,255,255,.15) 50%,
            rgba(255,255,255,.15) 75%,transparent 75%,transparent);
    background-size: 1rem 1rem;
}

.flash-sale__caroudel__item__price--progress__text{
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    color: #fff;
    font-size: 1.2rem;
}

.flash-sale__caroudel__item--discount{
    top: 0;
    right: 0;
    width: 4.5rem;
    height: 4.6rem;
    background-color: rgba(255, 216, 57, .8);
}

.flash-sale__caroudel__item--discount::after{
    content: "";
    width: 0;
    height: 0;
    left: 0;
    bottom: -7px;
    position: absolute;
    border-color: transparent rgba(255,212,36,.9);
    border-style: solid;
    border-width: 0 22.5px 8px;
}
</style>